import { Theme } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import FloorplanIcon from "../../assets/campaignBuilder/floorplan.svg";
import MapIcon from "../../assets/campaignBuilder/map.svg";
import PhotoIcon from "../../assets/campaignBuilder/photo.svg";
import VideoIcon from "../../assets/campaignBuilder/video.svg";
import { PreviewMode } from "./types";
import { MediaDialog } from "./content/dialogs/MediaDialog";
import { MapDialog } from "./content/dialogs/MapDialog";

export type MediaType = "photos" | "floorplan" | "video" | "";

interface DialogState {
  open: boolean;
  type: MediaType | null;
}

export const MediaUploadPanel = () => {
  const { t } = useTranslation(["campaignBuilder"]);

  const { previewMode } = useSelector(
    (state: any) => state.campaignBuilderSetup
  );

  const {
    imgFilesSlice,
    floorPlanFilesSlice,
    videoFilesSlice,
    floorPlanSectionOpen,
    mapSectionOpen,
    videoSectionOpen,
  } = useSelector((state: any) => state.campaignBuilder);
  const downMd = useMediaQuery((theme: Theme) => theme.breakpoints.down("md"));

  const [dialogState, setDialogState] = React.useState<DialogState>({
    open: false,
    type: null,
  });

  const handleOpenDialog = (e: any, type: MediaType) => {
    e.stopPropagation();

    const filesForType = getFilesForType(type);

    if (filesForType && filesForType.length > 0) {
      setDialogState({ open: true, type });
    }
  };

  const handleCloseDialog = () => {
    setDialogState({ open: false, type: null });
  };

  const getFilesForType = (type: MediaType | null) => {
    switch (type) {
      case "photos":
        return imgFilesSlice;
      case "floorplan":
        return floorPlanFilesSlice || [];
      case "video":
        return videoFilesSlice || [];
      default:
        return [];
    }
  };

  const [mapDialogOpen, setMapDialogOpen] = React.useState(false);
  const handleOpenMapDialog = () => {
    setMapDialogOpen(true);
  };
  const handleCloseMapDialog = () => {
    setMapDialogOpen(false);
  };

  return (
    <div
      className="meadia-upload-panel"
      style={{
        gap: previewMode === PreviewMode.MOBILE || downMd ? "10px" : "15px",
      }}
    >
      <MediaDialog
        files={getFilesForType(dialogState.type)}
        open={dialogState.open}
        setOpen={handleCloseDialog}
        mediaType={dialogState.type}
      />

      <MapDialog
        open={mapDialogOpen}
        handleCloseMapDialog={handleCloseMapDialog}
      />

      <div
        className="meadia-upload-panel-item"
        onClick={(e) => handleOpenDialog(e, "photos")}
      >
        <img src={PhotoIcon} />
        {previewMode === PreviewMode.MOBILE || downMd ? (
          <div>{imgFilesSlice.length}</div>
        ) : (
          <div>
            {imgFilesSlice.length} {t("photos")}
          </div>
        )}
      </div>

      {floorPlanSectionOpen && (
        <div
          className="meadia-upload-panel-item"
          onClick={(e) => handleOpenDialog(e, "floorplan")}
        >
          <img src={FloorplanIcon} alt="Floorplan Icon" />
          {previewMode === PreviewMode.DESKTOP && !downMd && (
            <div>{t("floorplan")}</div>
          )}
        </div>
      )}

      {videoSectionOpen && (
        <div
          className="meadia-upload-panel-item"
          onClick={(e) => handleOpenDialog(e, "video")}
        >
          <img src={VideoIcon} />
          {previewMode === PreviewMode.DESKTOP && !downMd && (
            <div>{t("video")}</div>
          )}
        </div>
      )}

      {mapSectionOpen && (
        <div className="meadia-upload-panel-item" onClick={handleOpenMapDialog}>
          <img src={MapIcon} />
          {previewMode === PreviewMode.DESKTOP && !downMd && (
            <div>{t("map")}</div>
          )}
        </div>
      )}
    </div>
  );
};
